import { Paper, PaperProps } from '@mui/material';
import {
  InvoiceManagementInvoiceFormProvider,
  InvoiceManagementInvoiceFormProviderProps,
} from './InvoiceManagementInvoiceFormProvider';

type Props = {
  invoiceFormProps: InvoiceManagementInvoiceFormProviderProps;
} & PaperProps;

export const InvoiceManagementInvoiceFormModule = ({ invoiceFormProps, sx, ...paperProps }: Props) => {
  return (
    <Paper
      variant={'outlined'}
      sx={{
        position: 'relative',
        flex: 1,
        p: {
          xs: 2,
          md: 4,
        },
        borderRadius: 0,
        maxWidth: '250mm',
        minHeight: '250mm',
        ...sx,
      }}
      {...paperProps}
    >
      <InvoiceManagementInvoiceFormProvider {...invoiceFormProps} />
    </Paper>
  );
};
